'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

require('./performance.now.polyfill');

var isLocal = window.location.host.indexOf("localhost") > -1 || window.location.host.indexOf("test") > -1;
var DEBUG = isLocal;
var domain = window.location.host.indexOf(".withlocals.com") > -1 ? ".withlocals.com" : undefined;
var expires = 999999;
var secure = true;
var cookieOptions = domain ? { domain: domain, expires: expires, secure: secure } : { expires: expires };

function ID() {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return Math.random().toString(36).substr(2, 12) + Math.random().toString(36).substr(2, 12) + Math.random().toString(36).substr(2, 12);
}

function createUserId() {
  var id = ID();
  // cookies.setItem('bitterbalid', id);
  localStorage.setItem('bitterbalid', id);
  _jsCookie2.default.set('bitterbalid', id, cookieOptions);
  return id;
}

function newSession() {
  return '\n  {"sessionId":"' + ID() + '"}\n  ';
}
var START = window.performance.now();

var Bitterbal = function () {
  function Bitterbal() {
    var _this = this;

    _classCallCheck(this, Bitterbal);

    try {
      this.userId = localStorage.getItem('bitterbalid') || _jsCookie2.default.get('bitterbalid') || createUserId();
      console.log("bitterbalid", this.userId);
      this.persistedVars = JSON.parse(window.localStorage.getItem('bitterbal') || '{}');
      this.sessionVars = JSON.parse(window.sessionStorage.getItem('bitterbal') || newSession());
    } catch (e) {
      this.persistedVars = {};
      this.sessionVars = {};
    }
    this.handleError = function (event) {
      var error = event.error;
      if (!error) return;
      var message = error.message;
      _this.push({ error: { message: message } });
    };
    window.addEventListener("error", this.handleError);
    var onLoadParams = {
      screen: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    };
    if (window.performance && window.performance.toJSON) {
      onLoadParams.performance = window.performance.toJSON();
    }
    this.push({ event: "loaded", payload: onLoadParams });
  }

  _createClass(Bitterbal, [{
    key: 'addToSession',
    value: function addToSession(params) {
      this.sessionVars = _extends({}, this.sessionVars, params);
      try {
        window.sessionStorage.setItem('bitterbal', JSON.stringify(this.sessionVars));
      } catch (e) {
        // nothing
      }
    }
  }, {
    key: 'addToPersisted',
    value: function addToPersisted(params) {
      this.persistedVars = _extends({}, this.persistedVars, params);
      try {
        window.localStorage.setItem('bitterbal', JSON.stringify(this.persistedVars));
      } catch (e) {
        // nothing
      }
    }
  }, {
    key: 'push',
    value: function push(event) {
      this.addBitterbal(_extends({
        event: event
      }, this.bitterbalExtraParams()));
    }
  }, {
    key: 'bitterbalExtraParams',
    value: function bitterbalExtraParams() {
      return {
        userId: this.userId,
        session: this.sessionVars,
        persisted: this.persistedVars,
        time: performance.now() - START
      };
    }
  }, {
    key: 'postBitterbal',
    value: function postBitterbal(params) {
      try {
        fetch("https://bitterbal.withlocals.com", {
          body: JSON.stringify(params),
          method: 'POST',
          mode: 'cors',
          headers: { 'Content-Type': 'application/json' }
        }).catch(function (e) {
          console.error("error posting to bitterbal", e, JSON.stringify(params));
        });
      } catch (e) {
        console.error("error posting to bitterbal", e, JSON.stringify(params));
      }
    }
  }, {
    key: 'addBitterbal',
    value: function addBitterbal(params) {
      if (DEBUG) {
        console.log("[BITTERBAL] " + JSON.stringify(params));
      }
      this.postBitterbal(params);
    }
  }]);

  return Bitterbal;
}();

exports.default = Bitterbal;